// PROMPT 3.4 Defect N — shared tag normalizer.
// Deterministic rule chain used by BOTH the /api/catalog/options builder
// and the /api/quiz/resolve filter engine. Every tag comparison in the
// quiz surface goes through canonicalizeTagValue() + deepEqualTag().

// Layout aliases: the store uses "75-percent" but the canonical user-
// facing form is "75%". Both must match.
const LAYOUT_ALIASES = {
        '60-percent': '60%',
        '65-percent': '65%',
        '75-percent': '75%',
        '80-percent': '80%',
        '100-percent': '100%',
        'full-size': 'full',
        'tkl': 'tkl',
};

// Prefixes that mark a namespaced tag ("switch:linear") — stripped before
// value comparison.
const NAMESPACE_PREFIXES = ['category:', 'switch:', 'layout:', 'form-factor:', 'sensor:', 'shape:', 'size:', 'weight:', 'polling:', 'brand:'];

export function canonicalizeTagValue(raw) {
        if (raw == null) return '';
        let s = String(raw).toLowerCase().trim();
        // Strip namespace prefixes
        for (const p of NAMESPACE_PREFIXES) {
                if (s.startsWith(p)) { s = s.slice(p.length); break; }
        }
        // Whitespace / underscores → dashes
        s = s.replace(/[_\s]+/g, '-');
        // Collapse consecutive dashes
        s = s.replace(/-+/g, '-');
        // Apply layout aliases (both directions handled here)
        if (LAYOUT_ALIASES[s]) return LAYOUT_ALIASES[s];
        return s;
}

export function deepEqualTag(a, b) {
        return canonicalizeTagValue(a) === canonicalizeTagValue(b);
}

// Extract the namespace key from a tag (for keying options by attribute).
// Returns "" when the tag is not namespaced.
export function tagKey(raw) {
        if (raw == null) return '';
        const s = String(raw).toLowerCase().trim();
        for (const p of NAMESPACE_PREFIXES) {
                if (s.startsWith(p)) return p.slice(0, -1); // drop trailing ":"
        }
        return '';
}
